import { fetchCategories } from "../../../services/catalog.api";

export const getAllCategories = async () => {
  try {
    return await fetchCategories();
  } catch (error) {
    console.error("Error fetching categories:", error);
    return [];
  }
};
